import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "fields-row" }
const _hoisted_4 = { class: "field-wrap" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "field-wrap" }
const _hoisted_7 = { class: "weekday-grid" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "weekday-chip__short" }
const _hoisted_10 = { class: "weekday-chip__label" }
const _hoisted_11 = { class: "save-row" }
const _hoisted_12 = {
  key: 0,
  class: "save-success"
}
const _hoisted_13 = {
  key: 0,
  class: "save-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"card-header\" data-v-11e26a46><div class=\"card-icon\" data-v-11e26a46><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-11e26a46><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" data-v-11e26a46></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\" data-v-11e26a46></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\" data-v-11e26a46></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" data-v-11e26a46></line></svg></div><div data-v-11e26a46><h3 class=\"card-title\" data-v-11e26a46>Presenças</h3><p class=\"card-desc\" data-v-11e26a46>Define o horário padrão sugerido ao marcar presença dos funcionários.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            class: "field-label",
            for: "attendance-start-time"
          }, "Horário padrão de entrada", -1)),
          _createElementVNode("input", {
            id: "attendance-start-time",
            class: "field-input",
            value: _ctx.form.attendanceStartTime,
            type: "time",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-form', { field: 'attendanceStartTime', value: ($event.target as HTMLInputElement).value })))
          }, null, 40, _hoisted_5),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "field-hint" }, "Esse valor aparece como sugestão ao marcar alguém como presente.", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "field-label" }, "Dias da semana trabalhados", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WEEKDAYS, (day) => {
              return (_openBlock(), _createElementBlock("button", {
                key: day.value,
                class: _normalizeClass(["weekday-chip", { active: _ctx.isWorked(day.value) }]),
                type: "button",
                onClick: ($event: any) => (_ctx.toggleDay(day.value))
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(day.short), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(day.label), 1)
              ], 10, _hoisted_8))
            }), 128))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "field-hint" }, "Dias fora dessa lista aparecem como opcionais no gerenciamento de usuários.", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn-save",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save')))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          width: "15",
          height: "15",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.2"
        }, [
          _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
          _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
          _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
        ], -1),
        _createTextVNode(" Salvar configurações ", -1)
      ]))]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.successText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.successText), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.errorText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.errorText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}